// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TournamentCard__root--ZaLAO {
    scroll-snap-align: center;
    width: 100%;
    cursor: pointer;
}

.TournamentCard__imageWrap--j44y5 {
    width: 100%;
    height: 156px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-bottom: 16px;
    border-radius: 6px;
    box-shadow: inset 0px 1px 0px rgba(111, 111, 111, 0.25);
}

.TournamentCard__image--RtpBZ {
    width: 60px;
    height: auto;
}

.TournamentCard__infoWrap--a4Oyl {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.TournamentCard__badges--Qd0n4 {
    display: flex;
    gap: 8px;
}

.TournamentCard__badge--OVDD0 {
    padding: 6px;
}

.TournamentCard__date--_sn0_ {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #85909D;
}

.TournamentCard__name--phYr_ {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: var(--tertiary-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui-v2/components/CS/TournamentCard/TournamentCard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;AAChC","sourcesContent":[".root {\n    scroll-snap-align: center;\n    width: 100%;\n    cursor: pointer;\n}\n\n.imageWrap {\n    width: 100%;\n    height: 156px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin-bottom: 16px;\n    border-radius: 6px;\n    box-shadow: inset 0px 1px 0px rgba(111, 111, 111, 0.25);\n}\n\n.image {\n    width: 60px;\n    height: auto;\n}\n\n.infoWrap {\n    margin-bottom: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.badges {\n    display: flex;\n    gap: 8px;\n}\n\n.badge {\n    padding: 6px;\n}\n\n.date {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #85909D;\n}\n\n.name {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--tertiary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TournamentCard__root--ZaLAO`,
	"imageWrap": `TournamentCard__imageWrap--j44y5`,
	"image": `TournamentCard__image--RtpBZ`,
	"infoWrap": `TournamentCard__infoWrap--a4Oyl`,
	"badges": `TournamentCard__badges--Qd0n4`,
	"badge": `TournamentCard__badge--OVDD0`,
	"date": `TournamentCard__date--_sn0_`,
	"name": `TournamentCard__name--phYr_`
};
export default ___CSS_LOADER_EXPORT___;
